import { API_URL } from '../config/connect';

const request = async (path, { method = 'GET', body } = {}) => {
    const googleIdToken = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            'Accept': 'application/json',
            ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
            Authorization: `Bearer ${googleIdToken}`,
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const errorBody = await response.json().catch(() => ({ message: response.statusText }));
        const detail = errorBody.detail;
        const errorMessage =
            (typeof detail === 'string' && detail) ||
            detail?.[0]?.msg ||
            detail?.message ||
            errorBody.message ||
            JSON.stringify(errorBody);
        const error = new Error(`Error ${response.status}: ${errorMessage}`);
        error.status = response.status;
        error.detail = errorMessage;
        throw error;
    }
    return response.json();
};

const toQuery = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') qs.set(key, value);
    });
    return qs.toString();
};

/**
 * Все заказы приложения: { items, total, pages, summary: { by_status, paid_count, paid_amount } }.
 * @param {Object} params - page, limit, q (ID / имя / телефон), status ('a,b'), payment_status,
 *   payment_method, user_id, created_from, created_to, sort
 */
const getAdminOrders = (params = {}) => request(`/api/v1/admin/orders?${toQuery(params)}`);

/** Карточка заказа: товары, покупатель/продавец, история статусов, транзакции. */
const getAdminOrder = (orderId) => request(`/api/v1/admin/orders/${orderId}`);

/** { status, note, refund = true, notify = true } → { refunded, order } */
const setAdminOrderStatus = (orderId, body) =>
    request(`/api/v1/admin/orders/${orderId}/status`, { method: 'POST', body });

/** { notes, delivery_address, pickup_address, delivery_date, loading_date } → { order } */
const updateAdminOrder = (orderId, body) =>
    request(`/api/v1/admin/orders/${orderId}`, { method: 'PATCH', body });

/** Непустые корзины: { items, total, pages, summary: { items_total, amount_total } } */
const getAdminCarts = (params = {}) => request(`/api/v1/admin/carts?${toQuery(params)}`);

/** Содержимое корзины пользователя: items (обычные), china_items, user. */
const getAdminCart = (userId) => request(`/api/v1/admin/carts/${userId}`);

/** kind: 'regular' | 'china' → { cart } */
const deleteAdminCartItem = (userId, itemId, kind = 'regular') =>
    request(`/api/v1/admin/carts/${userId}/items/${itemId}?kind=${kind}`, { method: 'DELETE' });

const clearAdminCart = (userId) => request(`/api/v1/admin/carts/${userId}`, { method: 'DELETE' });

export {
    getAdminOrders,
    getAdminOrder,
    setAdminOrderStatus,
    updateAdminOrder,
    getAdminCarts,
    getAdminCart,
    deleteAdminCartItem,
    clearAdminCart,
};
